import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';

import { azureAuthentication } from 'utils/functions/authentication';
import commonStrings from 'modules/common/strings';
import { contextToPageNameMap } from 'constants/context';

import { Wrapper, PageName, UserNameWrapper, UserName, LogoutPopup, Logout } from './Header.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
const { logoutPopup } = azureAuthentication();
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const Header = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const context = useSelector(state => state.common.context);

  const userNameWrapperRef = useRef(null);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isLogoutPopupOpen, setIsLogoutPopupOpen] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const handleClickOutside = event => {
      if (userNameWrapperRef.current && userNameWrapperRef.current.contains(event.target) === false)
        setIsLogoutPopupOpen(false);
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [userNameWrapperRef]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleUsernameClick = () => {
    setIsLogoutPopupOpen(prevState => !prevState);
  };

  const handleLogoutClick = () => {
    setIsLogoutPopupOpen(false);

    logoutPopup().then(() => {
      document.location.href = '/login';
    });
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  const pageName = contextToPageNameMap[context];
  const username = Cookies.get('nameAuthCookie') || Cookies.get('emailAuthCookie') || '';

  return (
    <Wrapper>
      <PageName>{pageName}</PageName>
      <UserNameWrapper ref={userNameWrapperRef}>
        <UserName
          onClick={() => handleUsernameClick()}
        >{`${commonStrings.header.userNameText} ${username}`}</UserName>
        {isLogoutPopupOpen && (
          <LogoutPopup>
            <Logout onClick={() => handleLogoutClick()}>{commonStrings.header.logoutText}</Logout>
          </LogoutPopup>
        )}
      </UserNameWrapper>
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
